import { request } from "./http";

export interface AiProviderOption {
  id: string;
  label: string;
  /** A key for this vendor is present on the server. */
  configured: boolean;
  /** The vendor enforces our response schema server-side. */
  strict_schema: boolean;
  recommended: boolean;
}

export interface AiSettings {
  provider: string;
  /** The ACTIVE provider has a key — i.e. the AI features actually work. */
  configured: boolean;
  providers: AiProviderOption[];
}

export function getAiSettings(): Promise<AiSettings> {
  return request("/platform/ai-settings");
}

export function setAiProvider(provider: string): Promise<AiSettings> {
  return request("/platform/ai-settings", { method: "PUT", body: { provider } });
}
